import { LEADS_SET_INCLUDE_CLOSED_OLDER_THAN_60 } from '../constants'

export function reducer(state, action) {
    if (action.type === LEADS_SET_INCLUDE_CLOSED_OLDER_THAN_60) {
        return {
            ...state,
            includeClosedOlderThan60Days: action.value
        }
    }
    return state
}
